<template>
  <div class="page-content" v-loading="pageLoading">
    <div class="info-detail">
      <div class="info-header">
        <div class="title">{{title}}</div>
        <div class="subinfo">發佈時間：{{ issueTime }}</div>
        <div class="subinfo">移除時間：{{ limitTime }}</div>
        <div class="subinfo">發佈人員：{{ name }}</div>
        <div class="intro">簡介：{{intro}}</div>
      </div>
    </div>
    <div class="border" />
    <div>
      <div class="media-block">
        <div class="label">雜誌封面</div>
        <el-image :src="coverImg" :preview-src-list="[coverImg]"/>
      </div>
      {{ content }}
      <div class="media-block pdf" v-if="file">
        <div class="label">PDF</div>
        <div class="pdf-content">
          <el-button type="primary" @click="download">下載
            <i class="el-icon-download el-icon--right"></i>
          </el-button>
          <iframe :src="file" class="pdf-preview" width="100%" height="600px"/>
        </div>
      </div>
      <div v-if="img.length>0" class="media-block">
        <div class="label">雜誌圖片</div>
        <div class="img" v-for="(item, index) in img" :key="index">
          <el-image :src="item"
              :preview-src-list="img"/>
        </div>
      </div>
      <div v-if="playerOptions.sources[0].src" class="media-block">
        <div class="label">雜誌視頻</div>
        <div class="video-box">
          <video-player class="video-player vjs-custom-skin"
                        ref="videoPlayer"
                        :playsinline="true"
                        :options="playerOptions"></video-player>
        </div>
      </div>
    </div>
    <el-button class="btn"
               @click="$router.back(-1)">返 回</el-button>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css';
import 'videojs-flash';
import { videoPlayer } from 'vue-video-player'; // 有多个输出值，引入花括号
export default {
  components: {
    videoPlayer
  },
  data () {
    return {
      pageLoading: false,

      title: '',
      issueTime: '',
      limitTime: '',
      name: '',
      intro: '',
      content: '',
      coverImg: '',
      img: [],
      file: '',
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: '',
            src: '' //视频url地址
          }
        ],
        // poster: '../../static/image/thumb_1_1380_460_20181009043014983386.jpg', //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      }
    };
  },
  mounted () {
    $('#pageHead').text('雜誌詳情');
    var id = sessionStorage.getItem('informationId');
    this.pageLoading = true
    this.axios({
      url: '/manage/getManInformation',
      params: {
        id: id
      }
    }).then(res => {
      if (res) {
        let msg = res.result[0];
        console.log(msg);
        this.title = msg.title;
        this.intro = msg.intro;
        this.name = msg.name;
        this.issueTime = msg.startInfoTime;
        this.limitTime = msg.endInfoTime;
        this.content = msg.content;
        if (msg.pictureFile) {
          this.img = msg.pictureFile.split(',');
        }
        this.file = msg.contentFile;
        this.playerOptions.sources[0].src = msg.videoFile;
        this.coverImg = msg.coverImg
      }
      this.pageLoading = false
    });
  },
  methods: {
    download () {
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = this.file;
      link.setAttribute('target', '_blank')
      link.setAttribute('download', '僱員手冊.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove()
    }
  }
};
</script>

<style scoped>
.page-content {
  padding: 0 3%;
}
p {
  color: #999;
}
hr {
  border-bottom: none;
  border-top: 3px solid #999;
}
.btn {
  position: absolute;
  top: 90px;
  right: 45px;
}
.img {
  max-height: 200px;
}
.video-box {
  max-width: 60%;
  margin: auto;
}
.title {
  margin-top: 12px;
  font-weight: 500;
  font-size: 28px;
  text-align: center;
}
.subinfo {
  color: #999;
  margin-top: 9px;
  text-align: center;
}
.intro {
  margin-top: 12px;
  font-size: 18px;
  text-indent: 2em;
}
.content {
  text-indent: 2em;
}
.border {
  width: 30%;
  margin: 24px auto;
  height: 1px;
  background: #ddd;
}
.media-block {
  display: flex;
  margin-bottom: 24px;
}
.media-block .label {
  width: 120px;
  font-weight: 550;
  text-align: right;
  margin-right: 12px;
}
.video-box {
  width: 90%;
}
.pdf-content {
  flex-grow: 100;
}
</style>
